import { useState } from 'react';
import styled from 'styled-components';
import { XCloseIcon } from '@rsos/assets/icons';
import { Box, Button, Text } from '@rsos/base-components';
import { CloseButton as DCCloseButton } from '@rsos/components/capstone/DataCards/DataCards.styles';
import EventPaneBanner from '../../../EventPaneBanner';
import TranscriptFeedbackModal from './TranscriptFeedbackModal';

interface TranscriptFeedbackProps {
  callerId: string;
}

export const CloseButton = styled(DCCloseButton)`
  margin-left: 7px;
  height: 20px;
`;

function TranscriptFeedback({ callerId }: TranscriptFeedbackProps) {
  const [show, setShow] = useState(true);
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);

  if (!show) {
    return null;
  }

  return (
    <>
      <EventPaneBanner padding="0px 20px">
        <Box horizontal justify="space-between" align="center" width="100%">
          <Text size="normal" color="background">
            How did Harmony AI perform?
          </Text>
          <Box horizontal align="center" flow={8}>
            <Button
              btnType="secondary"
              size="small"
              onClick={() => setIsFeedbackModalOpen(true)}
            >
              Send Feedback
            </Button>
            <CloseButton
              onClick={() => setShow(false)}
              data-testid="close-banner-button"
            >
              <XCloseIcon color="background" />
            </CloseButton>
          </Box>
        </Box>
      </EventPaneBanner>

      <TranscriptFeedbackModal
        isOpen={isFeedbackModalOpen}
        onClose={() => setIsFeedbackModalOpen(false)}
        callerId={callerId}
      />
    </>
  );
}

export default TranscriptFeedback;
